import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ComponentsModule } from 'app/client/components/main/components.module';
import { ClientComponent } from "./client.component";
import { ClientRoutingModule } from "./client-routing.module";
import { ServiceModule } from "app/services/service.module";

import { CallsModule } from "./call/list/calls.module";
import { CallDetailsModule } from "./call/details/call-details.module";
import { CallCreateModule } from "app/client/call/create/call-create.module";
import { ProfileModule } from "app/client/profile/profile.module";
import { ServiceObjectMapModule } from "./serviceObject/map/service-object-map.module";
import { LocationListModule } from "app/client/serviceObject/location/list/location-list.module";
import { AssetListModule } from "app/client/serviceObject/asset/list/asset-list.module";
import { LocationDetailsModule } from "app/client/serviceObject/location/details/service-object-details.module";
import { ServiceObjectSearchModule } from "app/client/serviceObject/search/serviceObject-search.module";
import { PlannedServiceListModule } from "app/client/plannedService/list/plannedService-list.module";
import { PlannedServiceDetailsModule } from "app/client/plannedService/details/plannedService-details.module";
import { UserListModule } from "./admin/user/list/user-list.module";
import { UserCreateModule } from "./admin/user/create/user-create.module";
import { UserUpdateModule } from "./admin/user/update/user-update.module";
import { NewPasswordModule } from "../account/asset/newPassword/newPassword-form.module";


@NgModule({
    declarations: [
      ClientComponent
    ],
    imports: [
      ServiceModule,
      CommonModule,
      CallsModule,
      ClientRoutingModule,
      ComponentsModule,
      AssetListModule,
      LocationListModule,
      UserListModule,
      UserCreateModule,
      UserUpdateModule,
      ServiceObjectMapModule,
      PlannedServiceListModule,
      PlannedServiceDetailsModule,
      LocationDetailsModule,
      CallDetailsModule,
      CallCreateModule,
      ProfileModule,
      ServiceObjectSearchModule,
      NewPasswordModule
    ]
})
export class ClientModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/client.module.ts